import { ModusIcon, ModusTooltip } from '@trimble-oss/modus-react-components';
import styles from './TextArea.module.css';

type TextAreaProps = {
  label?: string;
  value: string;
  onValueChange: (newValue: string) => void;
  required?: boolean;
  placeholder?: string;
  disabled?: boolean;
  tooltipText?: string;
  maxLength?: number;
};

export const TextArea = ({
  onValueChange,
  value,
  label,
  required,
  placeholder,
  disabled,
  tooltipText,
  maxLength,
}: TextAreaProps): JSX.Element => {
  return (
    <>
      {label && (
        <div className="label-container d-inline-flex justify-content-between align-items-center w-100">
          <div>
            <label>{label}</label>
            {required && <span className={`${styles.required}`}>*</span>}
          </div>
          {tooltipText && (
            <ModusTooltip position="left" text={tooltipText}>
              <ModusIcon name="help" />
            </ModusTooltip>
          )}
        </div>
      )}
      <textarea
        maxLength={maxLength}
        disabled={disabled}
        className={`form-control ${styles.textarea}`}
        data-testid="prompt-input"
        placeholder={placeholder}
        onChange={(event) => {
          onValueChange(event.target.value);
        }}
        value={value}
      />
    </>
  );
};
